import React from 'react';
import GfModal from '../../gfcomponents/GfModal/GfModal';
import moment from 'moment';
import { getDateTimeFormat } from '../../helpers/DateTimeUtility';
import { useDispatch } from 'react-redux';
import { NotificationData, NotificationsDispatch } from '../../notifications/notifications-types';
import { markForDelete } from '../../notifications/actions';
import './TransferCommentModal.scss';

export interface TransferCommentModalProps {
  commentNotifications: NotificationData[];
  onClose: () => void;
}

export default function TransferCommentModal(props: TransferCommentModalProps) {
  const dispatch = useDispatch<NotificationsDispatch>();

  const handleDismiss = () => {
    markForDelete(props.commentNotifications, dispatch);
    props.onClose();
  };

  const latestComment = props.commentNotifications.at(-1);

  const commenterName =
    latestComment.eventUserInfo?.initiatorName || `${latestComment.eventUserInfo?.initiatorFirstName} ${latestComment.eventUserInfo?.initiatorLastName}`;

  return (
    <GfModal
      className="transfer-comment-notification-modal"
      open
      onClose={props.onClose}
      title="You've received a new comment"
      primaryText="Dismiss"
      onPrimaryClick={handleDismiss}
    >
      <div className="transfer-comment-content">
        <div className="comment-body">
          <p>{latestComment.text}</p>
          <p>{`By ${commenterName} - ${moment.utc(latestComment.createdDate).local().calendar({ sameElse: getDateTimeFormat() })}`}</p>
        </div>
        <p className="help-text">
          Find all previous comments in the <strong>Actions menu</strong> when you open <strong>History</strong>.
        </p>
      </div>
    </GfModal>
  );
}
